// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) {});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)"
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });

    // Listen for the scroll event and log the event data
    lenis.on("scroll", (e) => {
        console.log(e);
    });
});

// Slider Logos
jQuery(document).ready(function ($) {
    var $logoSlider = $(".logo-slider");
    if ($logoSlider.length) {
        $logoSlider.on("init", function () {
            if (typeof AOS !== "undefined") {
                AOS.refresh();
            }
        });
        
        function initLogoSlider() {
            if (typeof $.fn.slick === "undefined") {
                setTimeout(initLogoSlider, 100);
                return;
            }
            
            const totalSlides = $logoSlider.children().length;
            const width = window.innerWidth;
            const slidesToShow = width <= 576 ? 2 : width <= 991 ? 3 : width <= 1150 ? 4 : width <= 1600 ? 5 : 6;
            const shouldCenter = totalSlides <= slidesToShow;
            
            $logoSlider.slick({
                dots: false,
                arrows: false,
                centerMode: !shouldCenter,
                slidesToShow: 6,
                slidesToScroll: 1,
                infinite: !shouldCenter,
                autoplay: !shouldCenter,
                autoplaySpeed: 0,
                cssEase: "linear",
                speed: 6000,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 5,
                        },
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: true,
                        },
                    },
                ],
            });
        }
        
        initLogoSlider();

        var resizeTimer;
        $(window).on("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                $logoSlider.slick("setPosition");
                if (typeof AOS !== "undefined") {
                    AOS.refresh();
                }
            }, 250);
        });

        function updateSliderAccess() {
            $logoSlider.find(".slick-slide img").attr("tabindex", "-1");
            $logoSlider.find(".slick-active img").attr("tabindex", "0");
        }

        $logoSlider.on("afterChange", updateSliderAccess);
        $logoSlider.on("init", updateSliderAccess);
        updateSliderAccess();
    }
});

// Slider cards
jQuery(document).ready(function ($) {
    var $slider = $(".cards-slider");
    var $title = $(".block-slider-block-cards-top-image-and-button__slider");
    var $controls = $(".slider-controls.mobile");
    var $wrapper = $(".container-arrows");

    function initCardsSlider() {
        if (typeof $.fn.slick === "undefined") {
            setTimeout(initCardsSlider, 100);
            return;
        }
        if ($slider.length) {
            $slider.slick({
                slidesToShow: 3,
                autoplay: false,
                autoplaySpeed: 3000,
                arrows: true,
                dots: false,
                prevArrow: $(".slider-cards-top-image-prev"),
                nextArrow: $(".slider-cards-top-image-next"),
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 2 } },
                    { breakpoint: 576, settings: { slidesToShow: 1 } },
                ],
            });

            AOS.refresh();

            function checkSlides() {
                var slickInstance = $slider.slick("getSlick");
                var totalSlides = slickInstance.$slides.length;
                var currentSlidesToShow = slickInstance.options.slidesToShow;

                if (totalSlides <= currentSlidesToShow) {
                    $title.addClass("few-items");
                    $controls.addClass("no-slider-controls");
                    $wrapper.addClass("few-items");
                } else {
                    $title.removeClass("few-items");
                    $controls.removeClass("no-slider-controls");
                    $wrapper.removeClass("few-items");
                }
            }

            $slider.on("init setPosition", function () {
                checkSlides();
            });

            $(window).on("resize orientationchange", function () {
                setTimeout(checkSlides, 200);
            });

            if ($slider.hasClass("slick-initialized")) {
                checkSlides();
            }
        }
    }
    
    initCardsSlider();
});

// Search & Filter: Scroll to top on pagination
function scrollToResults() {
    var target = jQuery(".sf-results-wrapper");
    if (!target.length) target = jQuery("main");

    if (target.length) {
        var headerHeight = jQuery("header.header-site").outerHeight() || 100;
        jQuery("html, body").animate(
            {
                scrollTop: target.offset().top - headerHeight - 30,
            },
            500
        );
    }
}
jQuery(document).on("click", ".pagination a", function () {
    scrollToResults();
});

jQuery(document).on("sf:ajaxfinish", function () {
    scrollToResults();
});

jQuery(document).ready(function ($) {
    if (window.location.href.indexOf("/page/") > -1) {
        setTimeout(function () {
            scrollToResults();
        }, 500);
    }
});

// Sticky element position
jQuery(document).ready(function ($) {
    var $stickyElement = $(".sticky-left-content");
    var $header = $("header.header-site");

    if ($stickyElement.length && $header.length) {
        function updateStickyPosition() {
            var headerHeight = $header.outerHeight();
            $stickyElement.css("top", headerHeight + 50 + "px");
        }

        updateStickyPosition();

        $(window).on("resize", updateStickyPosition);

        if (typeof ResizeObserver !== "undefined") {
            var resizeObserver = new ResizeObserver(function () {
                updateStickyPosition();
            });
            resizeObserver.observe($header[0]);
        }
    }
});

// Slider featured gallery content
jQuery(document).ready(function ($) {
    var $logoSlider = $(".hero-gallery-slider");
    if ($logoSlider.length) {
        $logoSlider.on("init", function () {
            if (typeof AOS !== "undefined") {
                AOS.refresh();
            }
        });
        
        function initHeroGallerySlider() {
            if (typeof $.fn.slick === "undefined") {
                setTimeout(initHeroGallerySlider, 100);
                return;
            }
            $logoSlider.slick({
                dots: false,
                arrows: false,
                centerMode: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: "linear",
                speed: 6000,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }
        
        initHeroGallerySlider();

        var resizeTimer;
        $(window).on("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                $logoSlider.slick("setPosition");
                if (typeof AOS !== "undefined") {
                    AOS.refresh();
                }
            }, 250);
        });

        function updateSliderAccess() {
            $logoSlider.find(".slick-slide img").attr("tabindex", "-1");
            $logoSlider.find(".slick-active img").attr("tabindex", "0");
        }

        $logoSlider.on("afterChange", updateSliderAccess);
        $logoSlider.on("init", updateSliderAccess);
        updateSliderAccess();
    }
});

document.addEventListener("DOMContentLoaded", function () {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    let revealTriggers = [];

    function initGSAPReveal() {
        revealTriggers.forEach((t) => t.kill());
        revealTriggers = [];

        const elements = document.querySelectorAll(".gs-reveal");

        elements.forEach(function (elem) {
            hide(elem);

            let tr = ScrollTrigger.create({
                trigger: elem,
                end: "bottom top",
                onEnter: function () {
                    animateFrom(elem, 1);
                },
                onEnterBack: function () {
                    animateFrom(elem, -1);
                },
                onLeave: function () {
                    hide(elem);
                },
            });
            revealTriggers.push(tr);
        });
    }

    function animateFrom(elem, direction) {
        direction = direction || 1;
        let x = 0,
            y = direction * 100;

        if (elem.classList.contains("gs-reveal-from-left")) {
            x = -100;
            y = 0;
        } else if (elem.classList.contains("gs-reveal-from-right")) {
            x = 100;
            y = 0;
        } else if (elem.classList.contains("gs-reveal-from-below")) {
            y = -100;
        }

        gsap.fromTo(
            elem,
            { x: x, y: y, autoAlpha: 0 },
            {
                duration: 1.25,
                x: 0,
                y: 0,
                autoAlpha: 1,
                ease: "expo",
                overwrite: "auto",
                delay: elem.classList.contains("gs-delay") ? 0.3 : 0,
            }
        );
    }

    function hide(elem) {
        gsap.set(elem, { autoAlpha: 0 });
    }

    initGSAPReveal();

    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            initGSAPReveal();
        }, 250);
    });
});

// Slider latest insights
jQuery(document).ready(function ($) {
    var $slider = $(".slider-latest-insights");
    var $title = $(".block-slider-block-cards-top-image-and-button__slider");
    var $controls = $(".slider-controls.mobile");
    var $wrapper = $(".container-arrows");

    function initLatestInsightsSlider() {
        if (typeof $.fn.slick === "undefined") {
            setTimeout(initLatestInsightsSlider, 100);
            return;
        }
        if ($slider.length) {
            $slider.slick({
                slidesToShow: 3,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: true,
                dots: false,
                prevArrow: $(".btn-arrow-prev"),
                nextArrow: $(".btn-arrow-next"),
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 2 } },
                    { breakpoint: 576, settings: { slidesToShow: 1 } },
                ],
            });

            AOS.refresh();

            function checkSlides() {
                var slickInstance = $slider.slick("getSlick");
                var totalSlides = slickInstance.$slides.length;
                var currentSlidesToShow = slickInstance.options.slidesToShow;

                if (totalSlides <= currentSlidesToShow) {
                    $title.addClass("few-items");
                    $controls.addClass("no-slider-controls");
                    $wrapper.addClass("few-items");
                } else {
                    $title.removeClass("few-items");
                    $controls.removeClass("no-slider-controls");
                    $wrapper.removeClass("few-items");
                }
            }

            $slider.on("init setPosition", function () {
                checkSlides();
            });

            $(window).on("resize orientationchange", function () {
                setTimeout(checkSlides, 200);
            });

            if ($slider.hasClass("slick-initialized")) {
                checkSlides();
            }
        }
    }
    
    initLatestInsightsSlider();
});
